import { useQuery } from "@tanstack/react-query";
import { UserTaskMimshakData } from "../../interfaces/DTO/userTask/UserTask";
import { userTaskMimshakDataService } from "../../services/userTask/userTaskMimshakDataService";

const USER_TASK_MIMSHAK_LIMIT = 500;

/** כל הפעולות (userTaskMimshakData) שנמצאו עבור אנשי הקשר */
export const useUserTaskMimshaksByContacts = (contactIds: number[], enabled: boolean = true) =>
  useQuery<UserTaskMimshakData[], Error>({
    queryKey: ["userTaskMimshakData", "byContacts", contactIds.join(",")],
    queryFn: async () =>
      (await userTaskMimshakDataService.getByContactSorted({
        contact_ids: contactIds,
        skip: 0,
        limit: USER_TASK_MIMSHAK_LIMIT,
      })) as UserTaskMimshakData[],
    enabled: enabled && contactIds.length > 0,
  });
